import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { setMenuLoading } from 'containers/Home/actions';

import SpecialBox from '../../components/SpecialBox';

class SpecialView extends Component {
  renderSec = () => {
    const { halfHalfSetup } = this.props;
    if (this.props.toggleAnimation === true) {
      return (
        <CSSTransition
          key={1}
          classNames='example1'
          timeout={{ enter: 500, exit: 500 }}
          component='div'
        >
          <SpecialBox
            key='1'
            setMenuLoading={this.props.setMenuLoading}
            boxIndex={this.props.boxIndex}
            menuItems={this.props.menuItems}
            addToSpecial={this.props.addToSpecial}
            showSpecialItem={this.props.showSpecialItem}
            addSpecialToOrder={this.props.addSpecialToOrder}
            halfHalfSetup={halfHalfSetup}
            selectedSpecials={this.props.selectedSpecials}
            specialItem={this.props.specialItem}
            filterView={this.props.filterView}
            rightSideViewVisibilityIndex={
              this.props.rightSideViewVisibilityIndex
            }
            itemExist={this.props.itemExist}
            storeConfig={this.props.storeConfig}
          />
        </CSSTransition>
      );
    } else {
      return (
        <CSSTransition
          key={2}
          classNames='example1'
          timeout={{ enter: 500, exit: 500 }}
          component='div'
        >
          <SpecialBox
            key='2'
            setMenuLoading={this.props.setMenuLoading}
            boxIndex={this.props.boxIndex}
            menuItems={this.props.menuItems}
            addToSpecial={this.props.addToSpecial}
            showSpecialItem={this.props.showSpecialItem}
            addSpecialToOrder={this.props.addSpecialToOrder}
            halfHalfSetup={halfHalfSetup}
            selectedSpecials={this.props.selectedSpecials}
            specialItem={this.props.specialItem}
            filterView={this.props.filterView}
            rightSideViewVisibilityIndex={
              this.props.rightSideViewVisibilityIndex
            }
            itemExist={this.props.itemExist}
            storeConfig={this.props.storeConfig}
          />
        </CSSTransition>
      );
    }
  };
  render() {
    return (
      <div
        className={
          this.props.rightSideViewVisibilityIndex === 3 ||
          (window.innerWidth > 991 &&
            !(
              window.navigator.userAgent.match(/iPad/i) &&
              window.innerHeight > 1250
            ) &&
            this.props.rightSideViewVisibilityIndex === 2)
            ? 'orderViews specialView active'
            : 'orderViews specialView'
        }
      >
        <div
          className='backToOrder thickcon-Left-Chevron'
          onClick={this.props.hideOrder}
        />
        <TransitionGroup className='order-items'>
          {this.renderSec()}
        </TransitionGroup>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    boxIndex: state.homeReducer.specialFilter.boxIndex,
    halfHalfSetup: state.layoutReducer.halfHalfSetup,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setMenuLoading: (val) => dispatch(setMenuLoading(val)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SpecialView);
